exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-elm-hot=\"true\"]{height:inherit}\n", ""]);

// exports
